import { LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/Logo";

const TopNavigation = () => {
  const { toast } = useToast();
  const { logout, getUser } = useAuth();
  const user = getUser();

  const handleLogout = () => {
    logout();
    toast({
      title: "Logged out",
      description: "You have been successfully logged out.",
    });
  };

  return (
    <header className="bg-muted px-4 h-16 lg:px-6">
      <div className="flex items-center justify-between h-full">
        {/* Logo for mobile */}
        <div className="lg:hidden">
          <Logo />
        </div>

        <div className="hidden lg:block" />

        {/* User info and logout */}
        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2 text-sm text-muted-foreground">
            <User className="h-4 w-4" />
            <span>Welcome, {user?.username ?? "User"}</span>
          </div>

          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            className="transition-all duration-300 hover:shadow-md"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default TopNavigation;
